import { createContext } from "react";

// Provides cross-tab product navigation: openProductInProducts(rozetkaId)
// Switches to the Products tab and filters to that product.
export const ProductNavContext = createContext(null);
